import React from 'react';
import { TextField } from 'src/components/ui/TextField';

const WebsiteClientForm = (props) => (
    <TextField
        {...props}
        variant="url"
        inputMode="url"
        autoComplete="url"
    />
);

export default WebsiteClientForm;
